import { render, staticRenderFns } from "./FilterGroupList.vue?vue&type=template&id=54c3ac86&scoped=true&"
import script from "./FilterGroupList.vue?vue&type=script&lang=js&"
export * from "./FilterGroupList.vue?vue&type=script&lang=js&"
import style0 from "./FilterGroupList.vue?vue&type=style&index=0&id=54c3ac86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3ac86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VSubheader})
